
import './style.scss';
import { Box, Typography } from '@mui/material';
import { IMuiIcon } from '../../interfaces/IMaterial';
import Button from '../Button';

interface ICardProps {
    image?: string;
    Icon?: IMuiIcon;
    color?: string;
    className?: string;
    title: string;
    description?: string;
    onClick?: () => void;
    buttonProps?: {
        label: string;
        fullWidth?: boolean;
        onClick?: () => void;
        Icon?: IMuiIcon;
        className?: string;
    },
    variant?: 'default' | 'wallpaper';
    chip?: string;
}


const Card: React.FC<ICardProps> = ({
    image = undefined,
    Icon = undefined,
    color = 'primary',
    className = '',
    title,
    description = '',
    onClick = () => { },
    buttonProps = undefined,
    variant = 'default',
    chip = undefined
}) => {
    if (variant === 'wallpaper') {
        return (
            <Box 
                className={`card-default variant-${variant} ${className}`} 
                onClick={onClick}
                sx={{
                    backgroundImage: `url(${image})`
                }}
            >
                <Box className={`card-backdrop`} />
    
                <Box className='card-content'>
                    <Box className='display-flex flexdirection-column gap-12'>
                        {
                            chip && <Typography variant='subtitle1' className='card-chip'> 
                                {
                                    Icon && <Icon />
                                }
                                {chip} 
                            </Typography>
                        }
                        
                        <Typography variant='subtitle1' className='card-title'> {title} </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box className={`card-default variant-${variant} ${className}`} onClick={onClick}>
            <Box 
                className={`card-image backgroundcolor-${color}`} 
                sx={{
                    backgroundImage: `url(${image})`
                }}
            >
                <Box className={`cardimage-backdrop backgroundcolor-${color}`} />
                
                {
                    Icon && <Icon className={`backgroundcolor-${color}`} />
                }
            </Box>

            <Box className='card-content'>
                <Typography variant='subtitle1' className='card-title'> {title} </Typography>
                <Typography variant='subtitle1' className='card-description'> {description} </Typography>
            </Box>

            {
                buttonProps && <Box className='card-footer'>
                    <Button 
                        label={buttonProps.label ?? ''}
                        className={`background-${color}`}
                        fullWidth={buttonProps.fullWidth ?? false}
                        onClick={buttonProps.onClick}
                        startIcon={buttonProps.Icon !== undefined ? <buttonProps.Icon fontSize='small' /> : undefined}
                    />
                </Box>
            }
        </Box>
    );
}

export default Card;